var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 108.2 122.9",
    style: {
      enableBackground: "new 0 0 108.2 122.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.7,1.2c-1.5-1.6-4-1.6-5.4,0L0.9,33.8c-2.1,2.4-0.4,6.1,2.7,6.1h11.6v79.2c0,2,1.6,3.7,3.7,3.7h28.7 c2,0,3.7-1.6,3.7-3.7V39.9h11.6c3.2,0,4.9-3.8,2.7-6.1L35.7,1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2,73.1h-6.3V31.8c0-2-1.6-3.7-3.7-3.7H84c-2,0-3.7,1.6-3.7,3.7v41.2h-6.3c-1.7,0-2.6,2.1-1.5,3.3L88.9,94 c0.8,0.9,2.2,0.9,2.9,0l15.9-17.7C108.8,75.1,107.9,73.1,106.2,73.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/Up.cea6cecc9d223e75b8528da8d56e851e.svg";
export { ForwardRef as ReactComponent };